import { render } from "./agenda.vue?vue&type=template&id=a380df7a&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"

import "./agenda.vue?vue&type=style&index=0&id=a380df7a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a380df7a"]])

export default __exports__